import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../../eventTriggers'

export function EducationHistory() {
  const { educations } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'education_history'))
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "education",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return (
    <div>
      {
        educations.map(education=>(
          <div key={education.id} onClick={()=>handleClick(education)} className="p-4 border-bottom clickable">
            <b>{education.school_name}</b>
            <div>{education.degree}</div>
          </div>
        ))
      }
    </div>
  )
}
